import sectionTextCarouselCss from '../css-snippets/section-text-carousel';

const textCarouselSection = `
<style>${sectionTextCarouselCss}</style>
<div
  class="text-carousel-section-unique-id"
  data-id="unique-id"
  data-attribute="card-container"
  data-background="#f9f9f9"
  data-pagination-active-color="#000000"
  data-pagination-inactive-color="#cccccc"
  data-background-item-color="#ffffff"
  data-text-item-color="#000000"
  data-top-padding="true" 
  data-bottom-padding="true"
  style="background-color: #f9f9f9; --pagination-active-color: #000000; --pagination-inactive-color: #cccccc; --background-item-color: #ffffff; --text-item-color: #000000;"
>
  <div class="container-page">
    <div class="wrap-card">
      <h2 data-attribute="card-title" class="card-title">
        Testimonials
      </h2>
      <div data-attribute="card-carousel" class="card-carousel">
        <div class="wrap-text-carousel">
          <div class="mySwiperTextCarousel">
            <div data-attribute="list-item" class="swiper-wrapper">
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-ct">
                  <div class="decor-item">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-quote"
                      viewBox="0 0 41 35"
                    >
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <div data-attribute="content" class="item-text">
                    <p style="text-align: center;">
                      The FrodoBots have been super fun; I've had both the Zero
                      and the Mini+. We've used them as marketing platforms for
                      our local shop, and I let my buddies from all over the
                      globe drive them and
                    </p>
                    <blockquote>
                      <p style="text-align: center;">Victor</p>
                      <p style="text-align: center;">Uk</p>
                    </blockquote>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-ct">
                  <div class="decor-item">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-quote"
                      viewBox="0 0 41 35"
                    >
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <div data-attribute="content" class="item-text">
                    <p style="text-align: center;">
                      As a 30+ year old adult, I wasn't sure what to expect when
                      I ordered the EarthRover Zero. I couldn't have been more
                      wrong. There's something incredibly satisfying about
                      remotely exploring my neighborhood from the comfort of my
                      desk, seeing familiar streets from a completely new
                      perspective.
                    </p>
                    <p style="text-align: center;">
                      It combines nostalgia with cutting-edge technology —
                      childhood joy with adult sophistication. I look forward to
                      my evening "rover sessions" — it's become my new way to
                      unwind. For any adults on the fence: don't let concerns
                      about it being "just a toy" hold you back. This is a
                      seriously enjoyable piece of technology.
                    </p>
                    <blockquote>
                      <p style="text-align: center;">Victor</p>
                      <p style="text-align: center;">Uk</p>
                    </blockquote>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-ct">
                  <div class="decor-item">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-quote"
                      viewBox="0 0 41 35"
                    >
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <div data-attribute="content" class="item-text">
                    <p style="text-align: center;">
                      Recently Ive been hearing about Frodobots. Small Remotely
                      controlled robots that people can drive across the world
                      via the internet! I became fascinated with the idea of
                      being able to wander around the world virtually. Then I
                      found out you can get your own Frodobot and drive it or
                      share it online to let others see your part of the world.
                      So I got myself a Frodobots Earth Rover Mini! With my new
                      Frodobot and the addition of an inexpensive pay-as-you-go
                      4G data plan. BOOM I'm part of something GREAT! I've had
                      endless fun driving around my area. It's wild to be able
                      to sit in the comfort of my house and wander the parks and
                      streets remotly. What makes it even better is, Frodo bots
                      is a game! As you rove around you find virtual items to
                      pick up for points! Some are easy to get to. some are
                      harder and require some skill to get to them. Overall I'm
                      super happy and glad I found my Frodobot!
                    </p>
                    <blockquote>
                      <p style="text-align: center;">Victor</p>
                      <p style="text-align: center;">Uk</p>
                    </blockquote>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-ct">
                  <div class="decor-item">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-quote"
                      viewBox="0 0 41 35"
                    >
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <div data-attribute="content" class="item-text">
                    <p style="text-align: center;">
                      Just received my Earth Rover Mini, and it has already
                      exceeded my expectations. It was very easy to set up, and
                      I was driving it within minutes. It came in a very nice
                      carrying case, with everything fitting neatly inside. I
                      honestly can't believe the quality and all the
                      functionalities included for the price. I've already
                      placed my order for a Zero and two of the Mini+ models so
                      I can drive them with all of my friends.
                    </p>
                    <blockquote>
                      <p style="text-align: center;">Victor</p>
                      <p style="text-align: center;">Uk</p>
                    </blockquote>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-ct">
                  <div class="decor-item">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-quote"
                      viewBox="0 0 41 35"
                    >
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <div data-attribute="content" class="item-text">
                    <p style="text-align: center;">
                      The FrodoBots have been super fun; I've had both the Zero
                      and the Mini+. We've used them as marketing platforms for
                      our local shop, and I let my buddies from all over the
                      globe drive them and
                    </p>
                    <blockquote>
                      <p style="text-align: center;">Victor</p>
                      <p style="text-align: center;">Uk</p>
                    </blockquote>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-ct">
                  <div class="decor-item">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-quote"
                      viewBox="0 0 41 35"
                    >
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <div data-attribute="content" class="item-text">
                    <p style="text-align: center;">
                      As a 30+ year old adult, I wasn't sure what to expect when
                      I ordered the EarthRover Zero. I couldn't have been more
                      wrong. There's something incredibly satisfying about
                      remotely exploring my neighborhood from the comfort of my
                      desk, seeing familiar streets from a completely new
                      perspective.
                    </p>
                    <p style="text-align: center;">
                      It combines nostalgia with cutting-edge technology —
                      childhood joy with adult sophistication. I look forward to
                      my evening "rover sessions" — it's become my new way to
                      unwind. For any adults on the fence: don't let concerns
                      about it being "just a toy" hold you back. This is a
                      seriously enjoyable piece of technology.
                    </p>
                    <blockquote>
                      <p style="text-align: center;">Victor</p>
                      <p style="text-align: center;">Uk</p>
                    </blockquote>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-ct">
                  <div class="decor-item">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-quote"
                      viewBox="0 0 41 35"
                    >
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <div data-attribute="content" class="item-text">
                    <p style="text-align: center;">
                      Recently Ive been hearing about Frodobots. Small Remotely
                      controlled robots that people can drive across the world
                      via the internet! I became fascinated with the idea of
                      being able to wander around the world virtually. Then I
                      found out you can get your own Frodobot and drive it or
                      share it online to let others see your part of the world.
                      So I got myself a Frodobots Earth Rover Mini! With my new
                      Frodobot and the addition of an inexpensive pay-as-you-go
                      4G data plan. BOOM I'm part of something GREAT! I've had
                      endless fun driving around my area. It's wild to be able
                      to sit in the comfort of my house and wander the parks and
                      streets remotly. What makes it even better is, Frodo bots
                      is a game! As you rove around you find virtual items to
                      pick up for points! Some are easy to get to. some are
                      harder and require some skill to get to them. Overall I'm
                      super happy and glad I found my Frodobot!
                    </p>
                    <blockquote>
                      <p style="text-align: center;">Victor</p>
                      <p style="text-align: center;">Uk</p>
                    </blockquote>
                  </div>
                </div>
              </div>
              <div data-attribute="item" class="swiper-slide">
                <div class="wrap-ct">
                  <div class="decor-item">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-quote"
                      viewBox="0 0 41 35"
                    >
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <div data-attribute="content" class="item-text">
                    <p style="text-align: center;">
                      Just received my Earth Rover Mini, and it has already
                      exceeded my expectations. It was very easy to set up, and
                      I was driving it within minutes. It came in a very nice
                      carrying case, with everything fitting neatly inside. I
                      honestly can't believe the quality and all the
                      functionalities included for the price. I've already
                      placed my order for a Zero and two of the Mini+ models so
                      I can drive them with all of my friends.
                    </p>
                    <blockquote>
                      <p style="text-align: center;">Victor</p>
                      <p style="text-align: center;">Uk</p>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</div>
`;
export default textCarouselSection;
